// extracted by mini-css-extract-plugin
module.exports = {"searchComponent":"_2Yp4Od9Eh0cYAgzLo7Oxt1","rating":"o9uvSfDL179HJk8oAYCqA","heart":"_1lzf6hCsauITxnPw35n2Hf","wrapper":"_3Xyw5vDjNnbtEN5xIOBMn1"};